const en = {
  eyebrow: 'How it works',
  title: 'From First Message to Final Setup',
  description:
    'Four steps, no surprises. Most clients book three to eight weeks ahead; rush orders are possible when flowers are in season.',
  stepLabel: 'Step',
  steps: [
    {
      title: 'Consultation',
      text: 'Call or WhatsApp us with your date, venue and colors. For events including both flowers and balloons, we discuss your complete vision. Most quotes go out the same day.',
    },
    {
      title: 'Design Proposal',
      text: 'You receive a mood board, flower/balloon list and a fixed price — revisions included. We send visual references for both services if applicable.',
    },
    {
      title: 'Confirmation',
      text: 'A 30% deposit reserves your date and we source the blooms fresh for that week. For balloon orders, we confirm color and theme selections.',
    },
    {
      title: 'Delivery & Setup',
      text: 'We arrive early, install everything on site and stay until the room is photo-ready. Your event looks exactly as envisioned.',
    },
  ],
  countdown: {
    title: 'Count down to your event',
    description: 'Tell us the date and we’ll tell you how much design time we have together.',
    label: 'Event date',
    empty: 'Choose a date to see how many days we have and what we recommend for that timeline.',
    day: 'day',
    days: 'days',
    away: 'away',
    cta: 'Check availability on WhatsApp',
    guidance: {
      past: { headline: 'That date has passed', detail: 'Pick an upcoming date and we’ll tell you what’s still possible.' },
      rush: { headline: 'Rush order', detail: 'Call us directly — balloons and in-season bouquets are usually possible.' },
      tight: { headline: 'Tight but doable', detail: 'Send your inspiration today; we’ll confirm availability within a few hours.' },
      ideal: { headline: 'Perfect timing', detail: 'Our ideal window — full proposal, revisions and sourcing all fit comfortably.' },
      early: { headline: 'Plenty of runway', detail: 'Reserve your date with a deposit and refine the design closer to the event.' },
    },
  },
}

const es: typeof en = {
  eyebrow: 'Cómo funciona',
  title: 'Desde el Primer Mensaje hasta la Instalación Final',
  description:
    'Cuatro pasos, sin sorpresas. La mayoría de los clientes reservan de tres a ocho semanas de anticipación; los pedidos urgentes son posibles cuando hay flores en temporada.',
  stepLabel: 'Paso',
  steps: [
    {
      title: 'Consulta',
      text: 'Llámenos o escríbanos por WhatsApp con su fecha, lugar y colores. Para eventos con flores y globos, conversamos sobre su visión completa. La mayoría de las cotizaciones salen el mismo día.',
    },
    {
      title: 'Propuesta de Diseño',
      text: 'Recibe un tablero de inspiración, la lista de flores/globos y un precio fijo — con revisiones incluidas. Enviamos referencias visuales de ambos servicios si aplica.',
    },
    {
      title: 'Confirmación',
      text: 'Un depósito del 30% reserva su fecha y conseguimos las flores frescas para esa semana. Para globos, confirmamos colores y tema.',
    },
    {
      title: 'Entrega e Instalación',
      text: 'Llegamos temprano, instalamos todo en el lugar y nos quedamos hasta que esté listo para las fotos. Su evento luce tal como lo imaginó.',
    },
  ],
  countdown: {
    title: 'Cuenta regresiva para su evento',
    description: 'Díganos la fecha y le diremos cuánto tiempo de diseño tenemos juntos.',
    label: 'Fecha del evento',
    empty: 'Elija una fecha para ver cuántos días faltan y qué le recomendamos.',
    day: 'día',
    days: 'días',
    away: 'faltan',
    cta: 'Consultar disponibilidad por WhatsApp',
    guidance: {
      past: { headline: 'Esa fecha ya pasó', detail: 'Elija una fecha próxima y le diremos qué es posible.' },
      rush: { headline: 'Pedido urgente', detail: 'Llámenos directamente — los globos y ramos de temporada suelen ser posibles.' },
      tight: { headline: 'Justo, pero posible', detail: 'Envíe su inspiración hoy; confirmamos disponibilidad en pocas horas.' },
      ideal: { headline: 'Momento perfecto', detail: 'Nuestro plazo ideal — propuesta, revisiones y compra de flores sin prisa.' },
      early: { headline: 'Tiempo de sobra', detail: 'Reserve su fecha con un depósito y afinamos el diseño más cerca del evento.' },
    },
  },
}

export const process = { en, es }
